import React from 'react'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbImage from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_image'
import DfbRte from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_rte'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'
import DfBButton from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_button'
import { conditionalLinkTarget } from '@dfb/gatsby-dfb-theme/src/components/utilities'
import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'
import { DistributorTeaser } from '../../types/types'

const MDistributor = ({ data }) => {
  const {
    headline,
    subheadline,
    description,
    teasers,
  }: { headline: string; subheadline: string; description: string; teasers: Array<DistributorTeaser> } = data

  const t = useTranslations()

  return (
    <Section baseClass="m-Distributor" data={data} defaultPadding="large">
      <div className="m-Distributor-wrapper">
        <div className="m-Distributor-container">
          <div className="m-Distributor-content">
            <div className="m-Distributor-head">
              {headline && <DfbHeadline headline={headline} headline_level="h2" add_class="m-Distributor-headline" />}
              {subheadline && <DfbHeadline headline={subheadline} headline_level="h4" add_class="m-Distributor-subline" />}
              {description && <p className="dfb-Paragraph m-Distributor-description">{description}</p>}
            </div>

            <div className="m-Distributor-hero-teasers">
              {teasers?.map(({ teasers_content }) => (
                <div className={`m-HeroTeaser${teasers_content?.[0]?.images?.[0]?.image?.[0] ? '' : ' m-HeroTeaser--textOnly'}`}>
                  <div className="m-HeroTeaser-wrapper">
                    <a
                      href={teasers_content[0].images[0].image_link_obj?.url}
                      {...conditionalLinkTarget(teasers_content[0].images[0].image_link, teasers_content[0].images[0].image_link_obj?.url)}
                      title={teasers_content[0].images[0]?.image_alternative || t('dfb_anchor.readmore')}
                      className="m-HeroTeaser-container"
                      style={{ color: 'inherit', textDecoration: 'inherit' }}
                    >
                      {teasers_content[0].image && teasers_content[0].image.length > 0 && (
                        <DfbImage
                          image={teasers_content[0].image[0]}
                          add_class="m-HeroTeaser-backgroundImage u-Image--xs u-Image-cover"
                          overlay="75"
                        />
                      )}
                      {teasers_content[0].images && teasers_content[0].images.length > 0 && (
                        <>
                          {teasers_content[0].images[0].image && teasers_content[0].images[0].image[0] && (
                            <DfbImage image={teasers_content[0].images[0].image[0]} add_class="m-HeroTeaser-foregroundImage" />
                          )}
                          <div className="m-HeroTeaser-content">
                            {teasers_content[0].kicker && <div className="m-HeroTeaser-topline">{teasers_content[0].kicker}</div>}
                            {teasers_content[0].images[0].image_headline && (
                              <DfbHeadline
                                headline={teasers_content[0].images[0].image_headline}
                                headline_level="h2"
                                add_class="c-Headline u-Theme-dark m-HeroTeaser-headline dfb-Headline--h2 dfb-Headline"
                              />
                            )}
                            {teasers_content[0].images[0].image_description && (
                              <DfbRte
                                text={teasers_content[0].images[0].image_description}
                                add_class="u-Theme-dark m-HeroTeaser-paragraph"
                              />
                            )}
                            {teasers_content[0].images[0].image_link_obj && (
                              <DfBButton
                                add_class="m-HeroTeaser-button u-Theme-dark"
                                text={teasers_content[0].images[0]?.image_alternative || t('dfb_anchor.readmore')}
                                tagName="div"
                              ></DfBButton>
                            )}
                          </div>
                        </>
                      )}
                    </a>
                    {(teasers_content[0].image?.[0]?.copyright || teasers_content[0].images?.[0]?.image?.[0]?.copyright) && (
                      <div className="m-HeroTeaser-copyright" style={{ gap: '8px' }}>
                        {teasers_content[0].image?.[0]?.copyright && <div>{teasers_content[0].image[0].copyright}</div>}
                        {teasers_content[0].images?.[0]?.image?.[0]?.copyright && (
                          <div>{teasers_content[0].images[0].image[0].copyright}</div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MDistributor
